<template>
  <div class="style-popup-wrapper" @touchmove.prevent>
    <w-popup-show :state="activeIndex === 0">
      <div slot="content" class="flex-column set-container">
        <div class="footer-middle flex-start">
          <span :class="{'active': activeIndex === 0}" class="flex-column-center" @click="changeIndex(0)">样式</span>
          <span :class="{'active': activeIndex === 1}" class="flex-column-center" @click="changeIndex(1)">排版</span>
        </div>
        <div class="style flex-between">
          <div v-for="(item, index) in changeStyle" :key="index" class="flex-column-center style-item"
               :class="{'style-item-active': optionIndex === index || (onePageShow && item.type === 'page')}"
               @click="changeOptionIndex(item, index)">
            <p class="icon-wrapper flex-center">
              <span class="iconfont" :class="item.icon"></span>
            </p>
            <span class="style-title">{{ item.title }}</span>
            <img src="https://files.wondercv.com/PC/editor/VIPtag.png" class="vip-icon" v-if="item.isVip" />
          </div>
        </div>
        <div class="options-wrapper">
          <cube-scroll ref="scroll" :data="[optionIndex]" direction="horizontal" class="horizontal-scroll-list-wrap">
            <ul class="list-wrapper options-container"
                :class="changeStyle[optionIndex].type === 'title_color' ? 'flex-between color-wrapper' : 'flex-center'">
              <template v-for="(val, index) in changeStyle[optionIndex].pickerData">
                <li v-if="changeStyle[optionIndex].type === 'title_color'" :key="index"
                    :style="{'background-color': val.value}" class="theme-color list-item"
                    :class="{'theme-color-active': val.value === changeStyle[optionIndex].value}"
                    @click="changeValue(val)"></li>
                <i v-else-if="changeStyle[optionIndex].type === 'font'" :key="index"
                   class="list-item iconfont options-item font"
                   :class="[val.font, {'options-item-active': val.value === changeStyle[optionIndex].value}]"
                   @click="changeValue(val)">
                   <img src="https://files.wondercv.com/PC/editor/VIPtag.png" class="vip-icon" v-if="val.isVip" />
                </i>
                <li v-else class="options-item list-item" :key="index"
                    :class="{'options-item-active': val.value === changeStyle[optionIndex].value}"
                    @click="changeValue(val)">
                  {{ val.name || val.value }}
                </li>
              </template>
            </ul>
          </cube-scroll>
        </div>
      </div>
    </w-popup-show>
    <w-popup-show :state="activeIndex === 1">
      <div slot="content" class="type-set set-container">
        <div class="footer-middle flex-start">
          <span :class="{'active': activeIndex === 0}" class="flex-column-center" @click="changeIndex(0)">样式</span>
          <span :class="{'active': activeIndex === 1}" class="flex-column-center" @click="changeIndex(1)">排版</span>
        </div>
        <cube-scroll :data="[activeIndex]">
          <template v-for="(item, index) in typesetting">
            <div class="flex-column type-setting-item" :key="index" v-if="index > 1">
              <p v-if="item.title" class="title">{{ item.title }}</p>
              <div class="flex-between picker-container"
                   v-if="item.switchShow ||
                   (switchValues.body_format && item.type === 'format_priority') ||
                   (!switchValues.body_format && item.type === 'punctuation_format')">
                <p class="picker-value">{{ item.switchTitle }}</p>
                <cube-switch v-model="switchValues[item.type]" @input="switchChange(item.type)" ></cube-switch>
              </div>
              <div class="picker-container flex-between" v-else-if="index < 3">
                <p class="picker-value">{{ item.pickerValue }}</p>
                <div class="picker-content flex-start">
                  <button v-for="(val, index) in item.pickerData" :key="index" @click="changeSetValue(item, val)"
                          :class="{'picker-active': item.value === val.value}"
                          :disabled="item.type === 'format_priority'&& typesetting[4].value === 'one_line'|| item.type === 'punctuation_format' && typesetting[4].value === 'two_line'">
                    {{ val.name }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </cube-scroll>
      </div>
    </w-popup-show>
    <div class="style-footer flex-between">
      <button class="iconfont iconx" @click="handleClose"></button>
 
      <button class="iconfont iconcheck" @click="handleClick" :disabled="!baseChange"></button>
    </div>
    <w-popup-show :state="quiteState" class="quite-wrapper">
      <div slot="content" class="quite-container">
        <div class="flex-center" @click="quiteChange">放弃修改</div>
        <div class="flex-center" @click="closeQuite">取消</div>
      </div>
    </w-popup-show>
  </div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import { changeStyle, fontFamilyCn, fontFamilyEn, typesetting } from '../../assets/json/cv-preview'
	import WPopupShow from '../../components/global/w-popup-show'
	import { componentsMixin } from '../../assets/js/mixin/components'

	let moment = require('moment')

	export default {
		name: 'style-popup',
		mixins: [ componentsMixin ],
		props: {
			styleState: {
				type: Boolean,
				default: false
			},
			onePageShow: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				activeIndex: null,
				optionIndex: 1,
				initEnd: false,
				cvStyle: {},
				field: [
					'title_color',
					'font',
					'font_size',
					'line_spacing',
					'page_margin',
					'head_format', 'time_format', 'format_priority', 'body_format', 'punctuation_format' ],
				quiteState: false
			}
		},
		mounted () {
		},
		computed: {
			...mapState('cv', [ 'cv', 'profiles', 'works']),
			// 样式调整的数据
			changeStyle () {
				return changeStyle
			},
			// 中文字体
			fontFamilyCn () {
				return fontFamilyCn
			},
			// 英文字体
			fontFamilyEn () {
				return fontFamilyEn
			},
			// 排版调整
			typesetting () {
				return typesetting
			},
			// 是否修改过
			baseChange () {
				if (this.styleState) {
					for (let i = 0; i < this.field.length; i++) {
						if (this.cvStyle.base[this.field[i]] !== this.cv.format_info[this.field[i]] || this.cvStyle.profile.show_attr_name !== this.profiles.show_attr_name) {
							return true
						}
					}
				}
			},
			// switch value
			switchValues () {
				let { format_info } = this.cv
				return {
					punctuation_format: format_info.punctuation_format === 'show_punctuation',
					body_format: format_info.body_format === 'two_line',
					format_priority: format_info.format_priority === 'city'
				}
			},
      isHasSubItem(){
			  return this.works.filter(item=> item.is_sub_item).length > 0
      }
		},
		watch: {
			styleState (val) {
				if (val && !this.initEnd) {
					this._initValue()
					this._saveCvBase()
				} else if (val) {
					this.activeIndex = 0
					this._saveCvBase()
				} else {
					this.activeIndex = null
				}
			}
		},
		components: {
			WPopupShow
		},
		methods: {
			...mapActions('cv', [ 'updateCvDetail', 'updateProfileData' ]),
			// 点击确定调接口更换样式
			async handleClick () {
				let { token } = this.$route.params
				let format_info = {}, payload = {}
				this.field.forEach(item => {
					format_info[item] = this.cv.format_info[item]
				})
				payload = {
					format_info: { ...format_info, page_size: this.cv.format_info.page_size },
					operation_type: 'update_format_info'
        }
        //检测标题颜色是否是当前模块颜色
        const titleColorJson = [ "#000000", "#CA3832", "#EE8732", "#4183FF", "#9C5BDE", "#6DB557"];
        let title_color  = payload?.format_info?.title_color || '';
        payload.format_info.title_select_color = titleColorJson.findIndex(item=> item===title_color) > -1 ? false : true

				let profilePayload = {
					show_attr_name: this.profiles.show_attr_name
				}
				this.updateProfileData({ token, payload: profilePayload })
				await this.updateCvDetail({ token, payload })
				this.$emit('change', 'change')
			},
			// 修改样式的值
			changeValue (val) {
				let type = this.changeStyle[this.optionIndex].type
				if (type === 'font') this.showToast('字体效果暂不支持预览<br/>请下载简历查看', 1500)
				this.changeStyle[this.optionIndex].value = val.value
				this.cv.format_info[type] = val.value
				this.$forceUpdate()
				setTimeout(() => {
					this.$parent.dealEmpty()
				}, 30)
			},
			switchChange (type) {
				let { format_info: { body_format, format_priority, punctuation_format } } = this.cv
				if (type === 'body_format') {
					this.cv.format_info.body_format = body_format === 'two_line' ? 'one_line' : 'two_line'
				} else if (type === 'format_priority') {
					this.cv.format_info.format_priority = format_priority === 'city' ? 'time' : 'city'
				} else if (type === 'punctuation_format') {
					this.cv.format_info.punctuation_format = punctuation_format === 'show_punctuation' ? 'not_show_punctuation' : 'show_punctuation'
				}
			},
			// 修改排版的值
			changeSetValue (item, val) {
				item.pickerValue = val.picker
				item.value = val.value
				item.type === 'show_attr_name' ? this.profiles.show_attr_name = val.value : this.cv.format_info[item.type] = val.value
				// item.type === 'show_attr_name' ? this.cv.profile.format_pref_show_attr_name = val.value : this.cv.base[item.type] = val.value
				this.$forceUpdate()
			},
			// 关闭弹窗
			handleClose () {
				if (this.baseChange) {
					this.quiteState = true
				} else {
					this.$emit('handleClose')
				}
			},
			// 切换样式 排版
			changeIndex (index) {
				this.activeIndex = index
			},
			// 切换样式中的选项
			changeOptionIndex (item, index) {
				if (index) {
					let startX = 0
					// 把当前设置的值滚动到可视区之内
					if (item.type === 'font_size' || item.type === 'line_spacing' || item.type === 'font') {
						const i = item.pickerData.findIndex(val => item.value === val.value)
						if (i > 0) startX = -(52 * i) + 52
					} else {
						this.startX = 0
					}
					this.optionIndex = index
					this.$refs.scroll.scrollTo(startX, 0, 300, 'easing')
				} else {
					this.$emit('onePage', true)
				}
			},
			// 初始化选中的样式
			_initValue () {
				this.activeIndex = 0
				if (this.cv.basic_info) {
					// 判断一下是英文简历还是中文简历选择font-family不同
					if (this.cv.basic_info.lang === 'cn') {
						this.changeStyle[1] = this.fontFamilyCn
					} else if (this.cv.basic_info.lang === 'en') {
						this.changeStyle[1] = this.fontFamilyEn
					}
					// 初始化高亮的数值
					this.changeStyle.forEach(item => {
						item.value = this.cv.format_info[item.type]
          })
					this.typesetting.forEach((item, index) => {
						// item.value = item.type === 'show_attr_name' ? this.cv.profile.format_pref_show_attr_name : this.cv.basic_info[item.type]
						if (index < 3) {
              item.value = item.type === 'show_attr_name' ? this.profiles.show_attr_name || 0 : this.cv.format_info[item.type]
              const index = item.pickerData.findIndex(v => v.value === item.value)
							item.pickerValue = item.pickerData[index] ? item.pickerData[index].picker : '-'
						}
					})
          setTimeout(() => {
	          this.changeOptionIndex(this.changeStyle[1], 1)
          }, 300)
					// console.log(this.changeStyle, this.optionIndex, '---')
					// 如果格式为一行标题显示的话要把  时间/地点优先  设置为时间优先，因为一行标题不显示地点
					if (this.typesetting[3].value === 'one_line') this.typesetting[2].value = 'time'
					// 如果返回的数据line_height大于28的时候要把行高设置为28
					if (this.changeStyle[3].value > 28) this.changeStyle[3].value = 28
					this.initEnd = true
				}
			},
			// 储存一下接口中的base值
			_saveCvBase () {
				this.cvStyle.base = JSON.parse(JSON.stringify(this.cv.format_info))
				this.cvStyle.profile = JSON.parse(JSON.stringify(this.profiles))
			},
			// 放弃修改
			quiteChange () {
				this.cv.format_info = JSON.parse(JSON.stringify(this.cvStyle.base))
				this.cv.profile = JSON.parse(JSON.stringify(this.cvStyle.profile))
				this.quiteState = false
				this.$emit('handleClose')
				this.activeIndex = null
				this.initEnd = false
				setTimeout(() => {
					this.$parent.dealEmpty()
				}, 30)
			},
			// 关闭放弃修改弹窗
			closeQuite () {
				this.quiteState = false
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .style-popup-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    color: $color-light;
    .w-popup {
      @include ipx-content-bottom(54px);
    }
    .style {
      padding: 24px 24px 16px;
      background-color: #181818;
      width: 100vw;
      .style-item {
        position: relative;
        .icon-wrapper {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #303030;
          margin-bottom: 8px;
          .iconfont {
            font-weight: 500;
            color: #9C9C9C;
          }
        }
        .style-title {
          font-size: $font-size-small;
          white-space: nowrap;
          color: #9C9C9C;
        }
        .vip-icon{
          width: 22px;
          position: absolute;
          top: -6px;
          right: -11px;
        }
      }
      .style-item-active {
        .style-title {
          color: $color-light;
        }
        .icon-wrapper {
          border: 1px solid $color-light;
          .iconfont {
            color: $color-light;
          }
        }
      }
    }
    .options-wrapper {
      padding: 0 8px;
      background-color: #181818;
      width: 100vw;
      height: 56px;
      .options-container {
        height: 24px;
      }
      .list-wrapper {
        min-width: 100vw;
        .options-item {
          text-align: center;
          color: $color-dark-gray;
          padding-right: 32px;
          &:first-child {
            padding-left: 30px;
          }
          &:last-child {
            /*margin-right: 30px;*/
          }
        }
        .options-item-active {
          font-size: $font-size-medium-x;
          color: $color-light;
        }
        .theme-color {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 4px solid #181818;
          box-sizing: content-box;
        }
        .theme-color-active {
          border-color: $color-light;
        }
      }
      ::v-deep .cube-scroll-list-wrapper {
        padding: 16px 0
      }
    }
    .set-container {
      @include ipx-content-bottom(54px);
      background: #181818;
      padding-top: 22px;
      .footer-middle {
        display: flex;
        justify-content: center;
        span {
          color: $color-dark-gray;
          line-height: 20px;
          margin-right: 60px;
          &:last-child {
            margin-right: 0;
          }
        }
        .active {
          font-size: $font-size-medium-x;
          line-height: 22px;
          color: $color-light;
          &:after {
            display: inline-block;
            content: '';
            width: 18px;
            height: 2px;
            border-radius: 1px;
            background-color: $color-theme;
            margin-top: 4px;
            margin-bottom: -4px;
            position: relative;
            z-index: 10;
          }
        }
      }
    }
    .type-set {
      height: 310px;
      background-color: #181818;
      width: 100vw;
      padding-top: 20px;
      @include ipx-footer(340px, 54px);
      .type-setting-item {
        padding: 0 30px;
        &:first-child{
          margin-top: 20px;
        }
        &:nth-child(1), &:nth-child(2), &:nth-child(3) {
          margin-bottom: 8px;
        }
        .title {
          font-size: $font-size-small;
          margin-bottom: 8px;
        }
        .picker-container {
          border-radius: 4px;
          background-color: #1f1f1f;
          padding: 12px;
          width: calc(100vw - 60px);
          height: 36px;
          color: $color-light;
          margin-bottom: 16px;
          .picker-value {
            color: #9C9C9C;
            white-space: nowrap;
          }
          .picker-content {
            button {
              color: $color-light;
              background: none;
              border: none;
              font-size: $font-size-medium;
              white-space: nowrap;
              padding: 0;
              width: 56px;
              text-align: right;
              &:disabled {
                color: $color-dark-gray;
              }
              &:last-child {
                margin-left: 24px;
              }
            }
            .picker-active {
              color: $color-theme;
            }
          }
          /deep/ .cube-switch .cube-switch-input:checked + .cube-switch-ui::after {
            transform: translateX(26px);
          }
          /deep/ .cube-switch-ui {
            width: 48px;
            height: 22px;
            &:after {
              width: 22px;
            }
          }
        }
      }
    }
    .style-footer {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 399;
      width: 100vw;
      background-color: #181818;
      color: $color-light;
      padding: 0 30px;
      @include ipx-footer(54px, 1px);
      .iconfont {
        font-size: 20px;
        font-weight: bold;
        color: $color-light;
      }
      button {
        background: none;
        border: none;
      }
      button:disabled {
        color: $color-dark-gray;
      }
    }
    .color-wrapper {
      padding: 0 50px;
    }
    .quite-wrapper {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 401;
      transform: translateY(0);
      @include ipx-content-bottom(1px);
      /deep/ .mask {
        transform: translateY(-100%);
      }
      .quite-container {
        border-radius: 10px 10px 0 0;
        background-color: $color-light;
        width: 100vw;
        div {
          height: 64px;
          color: $color-title;
          font-size: $font-size-medium-x;
          &:first-child {
            color: $color-theme;
            border-bottom: 1px solid #F9F9F9;
          }
        }
      }
    }
    .horizontal-scroll-list-wrap {
      /deep/ .cube-scroll-content {
        display: inline-block;
      }
      .list-wrapper {
        white-space: nowrap;
      }
      .list-item {
        display: inline-block;
        position: relative;
        &.font{
          .vip-icon{
            width: 22px;
            position: absolute;
            top: -8px;
            right: 20px;
          }
        }
      }
    }
  }
</style>
